import { Routes, Route, useNavigate } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import CreateListing from '../components/CreateListing';
import AddCar from '../components/AddCar';
import EditCar from '../components/EditCar';
import InspectionsList from '../components/InspectionsList';
import Dashboard from '../components/Dashboard';
import AdminManagement from '../components/AdminManagement';

export default function AdminDashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <div className="bg-gray-200 text-black flex min-h-screen">
      <AdminSidebar />
      <div className="flex-1 p-4">
        <div className="mb-4">
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 font-fairplay"
          >
            Logout
          </button>
        </div>
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="create-listing" element={<CreateListing />} />
          <Route path="add-car" element={<AddCar />} />
          <Route path="edit-car/:id" element={<EditCar />} />
          <Route path="inspections" element={<InspectionsList />} />
          <Route path="admin-management" element={<AdminManagement />} />
          <Route path="report" element={<div>Reports (To be implemented)</div>} />
        </Routes>
      </div>
    </div>
  );
}
